import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Col, Row, Label, Input } from "reactstrap";
import CustomSelect from "../../../../components/Forms/CustomSelect";
import SelectCustomStyles from "../../../../utils/styles/reactSelect";
import Select from "react-select";
import FixedSave from "../../../../components/Actions/FixedSave";
import { postForm } from '../../../../utils/helpers/api';

function CreateLeaveRequestPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [saveLoading, setSaveLoading] = useState(false);
  const [leaveRequestData, setLeaveRequestData] = useState({
    employee: '',
    employee_id: '',
    leave_type: '',
    start_date: new Date().toISOString().split('T')[0],
    end_date: new Date().toISOString().split('T')[0],
    reason: '',
    status: 'pending',
    attachment: null
  });

  const absenceTypesOptions = [
    { value: 'sick-leave', label: t('hr.sickLeave') },
    { value: 'authorized-leave', label: t('hr.authorizedLeave') },
    { value: 'unauthorized-leave', label: t('hr.unauthorizedLeave') },
    { value: 'annual-leave', label: t('hr.annualLeave') },
    { value: 'long-term-sick-leave', label: t('hr.longTermSickLeave') },
    { value: 'maternity-leave', label: t('hr.maternityLeave') },
    { value: 'paternity-leave', label: t('hr.paternityLeave') },
    { value: 'marriage-leave', label: t('hr.marriageLeave') },
    { value: 'bereavement-leave', label: t('hr.bereavementLeave') },
    { value: 'unpaid-leave', label: t('hr.unpaidLeave') },
    { value: 'training-study-leave', label: t('hr.trainingStudyLeave') }
  ];

  const saveLeaveRequest = async () => {
    setSaveLoading(true);
    const data = new FormData();
    data.append('employee_id', leaveRequestData.employee_id);
    data.append('leave_type', leaveRequestData.leave_type);
    data.append('start_date', leaveRequestData.start_date);
    data.append('end_date', leaveRequestData.end_date);
    data.append('total_days', leaveRequestData.total_days);
    data.append('reason', leaveRequestData.reason);
    data.append('status', leaveRequestData.status);
    if (leaveRequestData.attachment) {
      data.append('attachment', leaveRequestData.attachment);
    }

    Promise.resolve(postForm('/hr/leave-requests/store', data))
    .then(data => {
      setSaveLoading(false);
      navigate('/hr/leave-requests');
    })
    .catch(error => {
      setSaveLoading(false);
    });
  };

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={['Leave Requests', t('common.new') + ' Leave Request']}
          onBack={() => navigate('/hr/leave-requests')}
        />
        <div className="subheader-page-content scrollable">
          <Row>
            <Col md="6" className="mb-3">
              <Label>Employee </Label>
              <CustomSelect
                value={leaveRequestData.employee || null}
                onChange={selected => setLeaveRequestData({ ...leaveRequestData, employee: selected ? selected.label : '', employee_id: selected ? selected.value : null })}
                module="hr/employees"
                placeholder={t('common.search')}
                createLink="/hr/employees/create"
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Leave Type </Label>
              <Select
                value={absenceTypesOptions.filter(option => leaveRequestData.leave_type?.includes(option.value))}
                onChange={(selectedOptions) => setLeaveRequestData({ ...leaveRequestData, leave_type: selectedOptions.map(option => option.value) })}
                options={absenceTypesOptions}
                styles={SelectCustomStyles}
                isMulti
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Start Date </Label>
              <Input
                type="date"
                className="form-control"
                value={leaveRequestData.start_date}
                onChange={(e) => setLeaveRequestData({ ...leaveRequestData, start_date: e.target.value })}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>End Date </Label>
              <Input
                type="date"
                className="form-control"
                value={leaveRequestData.end_date}
                onChange={(e) => setLeaveRequestData({ ...leaveRequestData, end_date: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Total Days </Label>
              <Input
                type="number"
                className="form-control"
                value={leaveRequestData.end_date && leaveRequestData.start_date ? (new Date(leaveRequestData.end_date) - new Date(leaveRequestData.start_date)) / (1000 * 60 * 60 * 24) + 1 : ''}
                readOnly
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Status </Label>
              <Input type="select">
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                <option value="cancelled">Cancelled</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Reason </Label>
              <Input
                type="textarea"
                className="form-control"
                value={leaveRequestData.reason}
                onChange={(e) => setLeaveRequestData({ ...leaveRequestData, reason: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Attachment </Label>
              <Input
                type="file"
                onChange={(e) => setLeaveRequestData({ ...leaveRequestData, attachment: e.target.files[0] })}
              />
              <small style={{fontSize: '12px'}} className="text-muted">
                Accepted file types: PDF, DOC, DOCX. And maximum file size: 10MB.
              </small>
            </Col>
          </Row>
        </div>
      </div>

      <FixedSave
        onSave={saveLeaveRequest} 
        loading={saveLoading}
        disabled={
          !leaveRequestData.employee_id || 
          !leaveRequestData.leave_type || 
          !leaveRequestData.start_date ||
          !leaveRequestData.end_date ||
          !leaveRequestData.status ||
          saveLoading
        }
      />
    </SidebarLayout>
  );
}

export default CreateLeaveRequestPage;